__turbopack_context__.v({
  "icon-button": "IconButton-module-scss-module__7_KXtG__icon-button",
});
